/**
 * The two parts of the "Featured inside {project} + N others" statement,
 * shared by the desktop Tagged-Projects statement and the mobile Specified-in
 * heading so the wording never drifts between the two treatments.
 *
 * Reads as "Featured inside {name} Project + N others". "Project" is appended
 * only when the title doesn't already end with it (e.g. "Plum Location
 * Project"), so it never doubles up.
 */
export const getFeaturedInsideParts = (
    firstProjectTitle: string,
    othersCount: number,
) => {
    const projectTitle = firstProjectTitle.trim();
    const projectLabel = /\bproject$/i.test(projectTitle)
        ? projectTitle
        : `${projectTitle} Project`;
    const othersSuffix =
        othersCount > 0
            ? ` + ${othersCount} ${othersCount === 1 ? 'other' : 'others'}`
            : '';
    return { projectLabel, othersSuffix };
};
